<template>
	<div class="add_backimgIndex">
		<div class="clearfix">
			<img src="@/images/index_banner_new.png" class="index_banner_new" />
		</div>
		<div class="index_newdata clearfix">
			<div class="index_newdata_item">
				<img src="@/images/index_newdata_item1.png" />
				<div class="index_newdata_itemP1"><span>293</span>个</div>
				<div class="index_newdata_itemP2">自主开发-虚拟仿真实验数量</div>
			</div>
			<div class="index_newdata_item">
				<img src="@/images/index_newdata_item2.png" />
				<div class="index_newdata_itemP1"><span>103</span>个</div>
				<div class="index_newdata_itemP2">共享资源-虚拟仿真实验数量</div>
			</div>
			<div class="index_newdata_item">
				<img src="@/images/index_newdata_item3.png" />
				<div class="index_newdata_itemP1"><span>81</span>个</div>
				<div class="index_newdata_itemP2">校企共建-虚拟仿真实验数量</div>
			</div>
			<div class="index_newdata_item">
				<img src="@/images/index_newdata_item4.png" />
				<div class="index_newdata_itemP1"><span>108946</span>次</div>
				<div class="index_newdata_itemP2">实验访问次数</div>
			</div>
			<div class="index_newdata_item">
				<img src="@/images/index_newdata_item5.png" />
				<div class="index_newdata_itemP1"><span>23</span>个</div>
				<div class="index_newdata_itemP2">在线课程</div>
			</div>
		</div>
		<div class="content clearfix">
			<div class="index_others_new">
				<div class="index_title_new">新闻中心</div>
				<div class="clearfix">
					<div class="index_others_newone" v-if="index == 0" v-for="(item,index) in noticeList" @click.stop="toDetails(item)">
						<img :src="baseurl + item.cover" class="index_others_newoneicon" />
						<div class="index_others_newoneP1 text-ellipsis">{{item.title}}</div>
						<div class="index_others_newoneP2 text-ellipsistwo">
							{{item.description}}
						</div>
					</div>
					<div class="index_others_newmore">
						<div class="index_others_newmoreitem" @mousemove="activeNew = index" :class="{'active':activeNew == index}" v-if="index >0" v-for="(item,index) in noticeList" @click.stop="toDetails(item)">
							<div class="index_others_newmoreitemP1 text-ellipsis">{{item.title}}</div>
							<div class="index_others_newmoreitemTime">{{item.releaseTime}}</div>
							<div class="index_others_newmoreitemP2">
								{{item.description}}
							</div>
							<div class="index_others_newbtn" @click.stop="toName('news')">更多</div>
						</div>
					</div>
				</div>
			</div>
			<div class="index_others_new">
				<div class="index_title_new">中心介绍</div>
				<div class="clearfix">
					<video src="https://zfatt.oss-cn-beijing.aliyuncs.com/%E5%B1%B1%E4%B8%9C%E7%AC%AC%E4%B8%80%E5%8C%BB%E7%A7%91%E5%A4%A7%E5%AD%A6/%E6%99%BA%E8%83%BD%E5%8C%BB%E5%AD%A6%E5%BD%B1%E5%83%8F%E4%B8%8E%E6%94%BE%E5%B0%84%E6%B2%BB%E7%96%97%E8%99%9A%E6%8B%9F%E4%BB%BF%E7%9C%9F%E5%AE%9E%E9%AA%8C%E6%95%99%E5%AD%A6%E4%B8%AD%E5%BF%83%E8%A7%86%E9%A2%91.mp4" preload="auto" class="index_title_newvideo" controls="controls">
					</video>
				</div>
			</div>
			<div class="index_others_new">
				<div class="index_title_new">虚拟仿真实验</div>
				<div class="clearfix index_others_newliew">
					<div class="index_labs_newleft">
						<div class="index_labs_newleftitem" @click="toNameMore('lab1')">
							<div class="index_labs_newleftitemP1">自主开发</div>
							<div class="index_labs_newleftitemP2"><span>293</span>个</div>
							<div class="index_labs_newleftitemP3">自主开发-虚拟仿真实验数量</div>
							<div class="index_labs_newleftitemP4"></div>
						</div>
						<div class="index_labs_newleftitem" @click="toNameMore('lab2')">
							<div class="index_labs_newleftitemP1">共享资源</div>
							<div class="index_labs_newleftitemP2"><span>103</span>个</div>
							<div class="index_labs_newleftitemP3">共享资源-虚拟仿真实验数量</div>
							<div class="index_labs_newleftitemP4"></div>
						</div>
						<div class="index_labs_newleftitem" @click="toName('fictitious')">
							<div class="index_labs_newleftitemP1">校企共建</div>
							<div class="index_labs_newleftitemP2"><span>81</span>个</div>
							<div class="index_labs_newleftitemP3">校企共建-虚拟仿真实验数量</div>
							<div class="index_labs_newleftitemP4"></div>
						</div>
						<div class="index_labs_newmore" @click="toName('fictitious')">
							更多内容
						</div>
					</div>
					<div class="index_labs_newright">
						<emptymain :emptytext="'暂无实验'" :emptylist='experiments'></emptymain>
						<div class="index_labs_newitem" @click.stop="getLabInfo(item)" v-for="(item,index) in experiments">
							<div class="index_labs_newitemicon">
								<img :src="baseurl + item.cover" />
								<div class="index_labs_newitemicontype">
									{{item.mode == '3'?'训练':'考核'}}
								</div>
							</div>
							<div class="index_labs_newitemP1 text-ellipsis">{{item.name}}</div>
							<div class="index_labs_newitemP2">{{item.typeName || "虚拟仿真实验"}}</div>
							<div class="index_labs_newitemP3">{{item.clicks || 0}}人已浏览</div>
						</div>
					</div>
				</div>
			</div>
			<div class="index_others_new">
				<div class="index_title_new">在线课程</div>
				<div class="clearfix ">
					<div class="index_courses_newleft">
						<div class="index_courses_newleftitem" :class="coursetypeId == null ?'active':''" @click="typeChange(null)">热门课程</div>
						<div class="index_courses_newleftitem" :class="item.id == coursetypeId ?'active':''" v-for="(item, index) in majorList" @click="typeChange(item.id)">{{item.name}}</div>
						<div class="index_courses_newleftmore" @click="toName('courses')">
							更多内容+
						</div>
					</div>
					<div class="index_courses_newright">
						<emptymain :emptytext="'暂无课程'" :emptylist='courses'></emptymain>
						<div class="index_courses_newitem" @click.stop="toCourseindex(item)" v-for="(item,index) in courses">
							<div class="index_labs_newitemicon">
								<img :src="baseurl + item.banner" />
							</div>
							<div class="index_labs_newitemP1 text-ellipsis">{{item.name}}</div>
							<div class="index_labs_newitemP2">{{item.typeName || "虚拟仿真实验"}}</div>
							<div class="index_labs_newitemP3">{{item.signCount || 0}}人学习</div>
						</div>
					</div>
				</div>
			</div>
			<div class="index_others_new index_others_newfix">
				<div class="index_others_newfixitem" @click="toName('teacher')">
					<img src="@/images/index_others_newfixitem1.png" class="index_others_newfixitemback" />
					<div class="index_others_newfixtext">教学情况 <img src="@/images/index_others_newfixitem.png" /></div>
				</div>
				<div class="index_others_newfixitem" @click="toName('team')">
					<img src="@/images/index_others_newfixitem1.png" class="index_others_newfixitemback" />
					<div class="index_others_newfixtext">教学团队 <img src="@/images/index_others_newfixitem.png" /></div>
				</div>
				<div class="index_others_newfixitem">
					<img src="@/images/index_others_newfixitem1.png" class="index_others_newfixitemback" />
					<div class="index_others_newfixtext">职业能力测评 <img src="@/images/index_others_newfixitem.png" /></div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import { bannerList } from '@/api/banner'
	import { getListNoPager, appCourseList } from '@/api/course'
	import { majormainDO, listMajorByPid } from '@/api/major'
	import { noticeList, userIsRead } from '@/api/notice'
	import { vrDetailPage, vrPaperUserInit } from '@/api/simulation'
	import { collectionSave, collectionDelete } from '@/api/collection'
	import { userCollectionSave, userCollectionRemove, saveResourceDetailRecord } from '@/api/simulation.js'
	import { getStorageToken } from '@/utils/auth'
	export default {
		name: 'index',
		data() {
			return {
				activeNew: 1,
				current: 1,
				limit: 6,
				total: 0,
				majorList: [{
						"id": "10",
						"pid": null,
						"name": "影像设备",
						"description": "yxsb",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 6
					},
					{
						"id": "1047d8999ca21c9f39935a0f76e22abd",
						"pid": null,
						"name": "设备认知",
						"description": "sbrz",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 7
					},
					{
						"id": "11",
						"pid": null,
						"name": "成像原理",
						"description": "cxyl",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 1,
						"resourceDetailCount": 7
					},
					{
						"id": "12",
						"pid": null,
						"name": "CT检查技术",
						"description": "jcjs",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 2,
						"resourceDetailCount": 18
					},
					{
						"id": "13",
						"pid": null,
						"name": "DR检查技术",
						"description": "cszd",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 20
					},
					{
						"id": "14",
						"pid": null,
						"name": "MR检查技术",
						"description": "yxzd",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 9
					},
					{
						"id": "168ec1efaac3ad0d95b1958336cc32c6",
						"pid": null,
						"name": "超声检查技术",
						"description": "超声检查技术",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 5
					},
					{
						"id": "1a6d15c073d62b3b44523b36c11ce98f",
						"pid": null,
						"name": "影像诊断",
						"description": "yxzd",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 1,
						"resourceDetailCount": 0
					},
					{
						"id": "443871067af9a0e011b0ea4d55df2f25",
						"pid": null,
						"name": "介入检查技术",
						"description": "介入检查技术",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 1
					},
					{
						"id": "bdbb1ad7bed4a6c498bf40496a060d50",
						"pid": null,
						"name": "放射治疗技术",
						"description": "放射治疗技术",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 2
					},
					{
						"id": "c2dbdba65c3b5c1a712825d1cce7b599",
						"pid": null,
						"name": "MR教学课程",
						"description": "mr",
						"createuser": null,
						"createtime": null,
						"updateuser": null,
						"updatetime": null,
						"rank": null,
						"sparetwo": null,
						"status": null,
						"courseCount": 0,
						"resourceDetailCount": 5
					}
				],
				experiments: [{
						"id": "1468106455763787777",
						"majorId": "9",
						"typeId": "12",
						"name": "CT颅脑影像检查技术虚拟仿真系统（V3.0）",
						"introduction": "1.掌握CT头颅平扫、轴扫、螺旋（横断面）的摄影位置的检查目的及摄影方法。\n2.熟悉CT设备操作及摄影条件选择。\n3.观察CT设备数字图像显示部位，评价CT设备照片质量。\n",
						"introductionHtml": null,
						"scoreEvaluate": "<h1><strong style=\"font-size: 26px;\">1.实验内容：颅脑CT扫描</strong></h1><h1><strong style=\"font-size: 26px;\">2.实验器材：模拟CT设备、PACS、模拟铅衣、多媒体。</strong></h1><h1><strong style=\"font-size: 26px;\">3.实验步骤：</strong></h1><p>①先对操作CT机器开机，在进行第一步预热（warm up）→空气校正→点击Begin（开始）→点击NEXT扫描前的信息输入（姓名、年龄、性别、检查部位、摆放体位）→再点击NEXT（选择头部，会有参数信息显示）→再螺旋扫描。</p><p>②核对检查申请单、核对病人信息、是否填写完整、有无特殊要求、是否加急。</p><p>③选择好扫描参数：</p><p>窗宽（WW）1000-1500HU（骨窗）80-100HU（软组织）&nbsp;</p><p>窗位（WL）150-350HU&nbsp;&nbsp;35HU</p><p>层间距与层厚：8-10mm&nbsp;扫描10-12层面 扫描视野 200-250mm</p><p>④摆体位：请病人仰卧于摄影床上面，头向CT机，两手放与身体两旁，下颌内收，使头先进，使听眦线与X线平行（床面）轴扫，调节好床速，给病人做好防护，体位要摆对称，使每层图像两侧对称，以准确的反映该层面的解剖结构且便于双侧对照。扫描范围从枕骨大孔到颅顶，自足侧向头侧扫描（横断面扫描）。</p><p>冠状面扫描：颅脑冠状面扫描取仰卧位或俯卧位，头先进。仰卧位时取颌定位，俯卧位时取顶颌位，两者均要使扫描层与OML垂直。一般顶颌位较常用，病人也比较容易配合，要求以下颌为交点。头颅两侧基本对称，颅脑冠状面扫描从额叶到枕叶，鞍区扫描范围应视蝶鞍大小而定原则上包括蝶鞍前床突和后床突，有较大的占位性病变时应扩大扫描范围完整显示病变。</p><p>⑤ 结束扫描，嘱咐病人注意事项，请病人在外等候报告。</p><p><br></p>",
						"remark": "1.严重心、肝、肾功能衰竭。\n2.含碘对比剂过敏。",
						"clicks": 1996,
						"cover": "vr/cover/2022/03/01/1646102864906.jpg",
						"vrExamineState": 1,
						"sort": 1,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "3",
						"version": "1.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 3,
						"isCollection": true,
						"averageScore": null,
						"resourceId": "1420565903296397314",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					},
					{
						"id": "1569632366651887618",
						"majorId": "9",
						"typeId": "12",
						"name": "CT耳部影像检查技术虚拟仿真系统（V3.0）",
						"introduction": " \n",
						"introductionHtml": null,
						"scoreEvaluate": "<p> </p>",
						"remark": null,
						"clicks": 179,
						"cover": "vr/cover/2022/09/13/1663064457596.png",
						"vrExamineState": 1,
						"sort": 21,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "2",
						"version": "2.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 0,
						"isCollection": false,
						"averageScore": null,
						"resourceId": "1569635823945371649",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					},
					{
						"id": "1569632366651887618",
						"majorId": "9",
						"typeId": "12",
						"name": "CT耳部影像检查技术虚拟仿真系统（V3.0）",
						"introduction": " \n",
						"introductionHtml": null,
						"scoreEvaluate": "<p> </p>",
						"remark": null,
						"clicks": 132,
						"cover": "vr/cover/2022/09/13/1663064457596.png",
						"vrExamineState": 1,
						"sort": 21,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "3",
						"version": "2.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 1,
						"isCollection": false,
						"averageScore": null,
						"resourceId": "1569636002257817601",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					},
					{
						"id": "1569632057955307521",
						"majorId": "9",
						"typeId": "12",
						"name": "CT鞍区影像检查技术虚拟仿真系统（V3.0）",
						"introduction": " \n",
						"introductionHtml": null,
						"scoreEvaluate": "<p> </p>",
						"remark": null,
						"clicks": 113,
						"cover": "vr/cover/2022/09/13/1663064408754.png",
						"vrExamineState": 1,
						"sort": 20,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "3",
						"version": "2.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 1,
						"isCollection": false,
						"averageScore": null,
						"resourceId": "1569839847781027841",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					},
					{
						"id": "1569632057955307521",
						"majorId": "9",
						"typeId": "12",
						"name": "CT鞍区影像检查技术虚拟仿真系统（V3.0）",
						"introduction": " \n",
						"introductionHtml": null,
						"scoreEvaluate": "<p> </p>",
						"remark": null,
						"clicks": 118,
						"cover": "vr/cover/2022/09/13/1663064408754.png",
						"vrExamineState": 1,
						"sort": 20,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "2",
						"version": "2.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 0,
						"isCollection": false,
						"averageScore": null,
						"resourceId": "1569840027628589058",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					},
					{
						"id": "1468383723866234882",
						"majorId": "9",
						"typeId": "12",
						"name": "CT心脏影像检查技术虚拟仿真系统（V3.0）",
						"introduction": "无\n",
						"introductionHtml": null,
						"scoreEvaluate": "<p>无</p>",
						"remark": null,
						"clicks": 1087,
						"cover": "vr/cover/2022/03/01/1646102903704.jpg",
						"vrExamineState": 1,
						"sort": 14,
						"createUser": null,
						"createTime": null,
						"updateTime": null,
						"status": null,
						"mode": "3",
						"version": "1.0.0",
						"vrResourceDOs": null,
						"vrResourceStudy": null,
						"vrResourceExamine": null,
						"vrResourceDo": null,
						"majorName": "医学影像",
						"typeName": "CT检查技术",
						"createName": null,
						"collectionCount": 0,
						"isCollection": false,
						"averageScore": null,
						"resourceId": "1420561794082242562",
						"studyCount": null,
						"tasKCount": null,
						"dataList": null,
						"paperList": null,
						"taskName": null,
						"taskList": null,
						"hotSign": null,
						"code": null,
						"url": null,
						"attachPrefix": null,
						"video": null,
						"screen": null,
						"technical": null,
						"playback": null
					}
				],
				typeId: null,
				coursetypeId: null,
				courses: [{
						"id": "1730453902248910849",
						"name": "MRI软件操作（二）",
						"banner": "vr/mooc/2023/12/01/1701407334422.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "14",
						"typeName": "MR检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "MRI软件操作（二）",
						"infoFile": null,
						"overview": "<p>MRI软件操作（二）</p>",
						"references": null,
						"signCount": 776,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					},
					{
						"id": "1730453830748610562",
						"name": "MRI软件操作（一）",
						"banner": "vr/mooc/2023/12/01/1701407313324.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "14",
						"typeName": "MR检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "MRI软件操作（一）",
						"infoFile": null,
						"overview": "<p>MRI软件操作（一）</p>",
						"references": null,
						"signCount": 732,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					},
					{
						"id": "1730454080930455554",
						"name": "MRI图像后处理（二）",
						"banner": "vr/mooc/2023/12/01/1701407377257.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "14",
						"typeName": "MR检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "MRI图像后处理（二）",
						"infoFile": null,
						"overview": "<p>MRI图像后处理（二）</p>",
						"references": null,
						"signCount": 681,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					},
					{
						"id": "1730453459363962881",
						"name": "CT体膜测试",
						"banner": "vr/mooc/2023/12/01/1701407229095.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "12",
						"typeName": "CT检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "CT体膜测试",
						"infoFile": null,
						"overview": "<p>CT体膜测试</p>",
						"references": null,
						"signCount": 675,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					},
					{
						"id": "1730453412341620738",
						"name": "CT软件操作（三）",
						"banner": "vr/mooc/2023/12/01/1701407217711.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "12",
						"typeName": "CT检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "CT软件操作（三）",
						"infoFile": null,
						"overview": "<p>CT软件操作（三）</p>",
						"references": null,
						"signCount": 601,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					},
					{
						"id": "1730454018565349378",
						"name": "MRI图像后处理（一）",
						"banner": "vr/mooc/2023/12/01/1701407362241.png",
						"userId": "1730463493703606273",
						"teacherName": "山一大",
						"majorId": null,
						"typeId": "14",
						"typeName": "MR检查技术",
						"createTime": null,
						"updateTime": null,
						"status": null,
						"duration": null,
						"document": null,
						"info": "MRI图像后处理（一）",
						"infoFile": null,
						"overview": "<p>MRI图像后处理（一）</p>",
						"references": null,
						"signCount": 589,
						"collectionCount": 0,
						"isCollection": false,
						"filesSize": null,
						"chatGroupId": null,
						"beginTime": null,
						"endTime": null,
						"state": null,
						"publicWelfare": null,
						"socialType": null
					}
				],
				noticeList: [],
				indexAdShow: window.config.INDEX_AD_SHOW,
			}
		},
		created() {
			var token = getStorageToken();
			if(token) {
				this.getNotice();
				this.getMajormainDO();
				this.gettVrPaperDO();
				this.getCourse();
			}

		},
		mounted() {

		},
		methods: {
			openUrl() {
				window.open(window.config.INDEX_AD_URL)
			},
			typeChange(id) {
				var token = getStorageToken();
				if(token) {
					this.coursetypeId = id;
					this.getCourse();
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			getCourse() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.coursetypeId == this.majorIdForAll ? null : this.coursetypeId,
					current: 1,
					limit: 6,
				}
				appCourseList(data).then(res => {
					if(res.code == "OK") {
						this.courses = res.data.records;
					}
				})
			},
			getMajormainDO() {
				listMajorByPid({
					pid: this.majorIdForAll
				}).then(res => {
					this.majorList = res.data || [];
				})
			},
			gettVrPaperDO() {
				var data = {
					majorId: this.majorIdForAll,
					typeId: this.typeId,
					current: 1,
					limit: 6,
				}
				vrDetailPage(data).then(res => {
					this.experiments = res.data.records || [];
				})
			},
			//点击切换相应课程——展示列表
			handleClick(id) {
				this.typeId = id;
				this.gettVrPaperDO();
			},
			getLabInfo(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'fictitiousinfo',
						query: {
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			viewSimulation(item) {
				var vrDetailId = item.id;
				var resourceId = item.resourceId;
				var token = getStorageToken();
				if(token) {
					saveResourceDetailRecord({
						vrDetailId: vrDetailId,
						resourceId: resourceId,
					}).then(res => {
						if(item.mode && item.mode == '2') {
							if(item.version == '2.0.0') {
								window.open('#/fictitiousdetail?type=exam&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
							} else {
								vrPaperUserInit({
									vrDetailId: vrDetailId,
									resourceId: resourceId,
									expertype: item.typeId,
								}).then(res => { //判断是否有关联的试卷，存在则直接返回，不存在则创建后返回
									if(res.code == 'OK') {
										window.open('#/fictitiousdetail?type=index&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId + '&pid=' + res.data)
									}
								})
							}
						} else {
							window.open('#/fictitiousdetail?type=test&vrDetailId=' + vrDetailId + '&resourceId=' + resourceId)
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			getNotice() {
				noticeList({
					current: 1,
					limit: 6,
					state: 1
				}).then(res => {
					this.noticeList = res.data.records;
				})
			},
			toCourseindex(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: 'coursedetail',
						query: {
							courseId: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toNameMore(name) {
				var token = getStorageToken();
				if(token) {
					if(name == 'lab1') {
						window.open('http://121.249.143.40/mengoo/')
					}
					//					if(name == 'lab2') {
					//						window.open('')
					//					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toName(name) {
				var token = getStorageToken();
				if(token) {
					if(this.$router.name != name) {
						this.$router.push({
							name: name
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			toDetails(item) {
				var token = getStorageToken();
				if(token) {
					this.$router.push({
						name: "newsdetail",
						query: {
							id: item.id
						}
					})
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			//仿真收藏
			simulationCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						userCollectionSave({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.gettVrPaperDO();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						userCollectionRemove({
							vrDetailId: item.id,
							resourceId: item.resourceId,
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.gettVrPaperDO();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
			moocCollection(item) {
				var token = getStorageToken();
				if(token) {
					if(!item.isCollection) {
						collectionSave({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: "收藏成功!",
								})
								this.getCourse();
							} else {
								this.$message({
									type: 'error',
									message: res.data.message,
								})
							}
						})
					} else {
						collectionDelete({
							type: 'mooc',
							typeId: item.id
						}).then(res => {
							if(res.code == "OK") {
								this.$message({
									type: 'success',
									message: '取消成功!'
								});
								this.getCourse();
							}
						})
					}
				} else {
					this.$store.dispatch('user/openLogin', {
						loging: true
					})
				}
			},
		},
	}
</script>